import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';
@Injectable({
  providedIn: 'root'
})
export class NIPRApiService {
  apiName = "NIPRApiService"
  constructor(private readonly rest: RestService) { }


  GetAgent = (npn: string,ssn: string,lastname:string,isSendNotification: boolean=false) =>
  this.rest.request<any, Response>({
    method: 'POST',
    url: `/api/agent-infoservice/find-agent`,
    params: { NPN : npn,SSN : ssn,LastName : lastname,IsSendNotification:isSendNotification },
  },
  { apiName: 'default' });
  GetUser=()=>
  this.rest.request<any, number>({
    method: 'POST',
    url: `/api/user-detail/check-user-info`  
  },
  { apiName: 'default' });
  GetAgency = (npn: string,ssn: string,isSendNotification:boolean =false) =>
  this.rest.request<any, Response>({
    method: 'POST',
    url: `/api/agency-infoservice/find-agency`,
    params: { NPN : npn,SSN : ssn ,IsSendNotification:isSendNotification },
  },
  { apiName: 'default' });

  GetAgentWithEmail = (npn: string,ssn: string,lastname:string,email:string) =>
  this.rest.request<any, Response>({
    method: 'POST',
    url: `/api/agent-infoservice/find-agent-by-email`,
    params: { NPN : npn,SSN : ssn,LastName : lastname,Email : email },
  },
  { apiName: 'default' });
}
